import Notification from '@/models/notification';
import axios from 'axios';

export class NotificationsController {

    /**
     * Get the available list of notification
     *
     * @param {null|string} $notifiable_type The notifiable object type in question, if any
     * @param {null|string} $notifiable_id The notifiable object id in question, if any
     * @returns {Notification|Error} An notification model or an error object
     */
    static async index($notifiable_type, $notifiable_id) {  
        let response;   
        if(!($notifiable_type ?? false) && !($notifiable_id ?? false)) {
            response = axios.get('notifications')
            .then(resp => resp.data.map(notification => new Notification(notification)))
            .catch((error) => Promise.reject(error));
        } else {
            response = axios.get(`notifications/${$notifiable_type}/${$notifiable_id}`)
            .then(resp => new Notification(resp.data))
            .catch((error) => Promise.reject(error));
        }

        return await response;
    }
    
    /**
     * Create a notification model
     *
     * @param void
     * @returns {Notification|Error} An notification model or an error object
     */
    static async store($notification) {
        let response = axios
            .post('notifications', $notification)
            .then((resp) => new Notification(resp.data))
            .catch((error) => Promise.reject(error))
        return await response
    }
    
    /**
     * Update a notification model
     *
     * @param Notification $notification model
     * @returns {Notification|Error} An notification model or an error object
     */
    static async update($notification) {
        let response = axios
            .patch(`notifications/${$notification.id}`, $notification)
            .then((resp) => new Notification(resp.data))
            .catch((error) => Promise.reject(error))
        return await response
    }

    /**
     * Soft delete a notification model
     *
     * @param Notification $notification model
     * @returns {Notification|Error} An notification model or an error object
     */
    static async delete($notification) {
        let response = axios
            .delete(`notifications/${$notification.id}`)
            .then((resp) => new Notification(resp.data))
            .catch((error) => Promise.reject(error))
        return await response
    }

    /**
     * Restore a notification model
     *
     * @param Notification $notification model
     * @returns {Notification|Error} An notification model or an error object
     */
    static async restore($notification) {
        let response = axios
            .patch(`notifications/${$notification.id}/restore`, $notification)
            .then((resp) => new Notification(resp.data))
            .catch((error) => Promise.reject(error))
        return await response
    }

}